import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import MetisMenu from "metismenujs";
import withRouter from "../Common/withRouter";
import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changePreloader,
  verify_admin,
  getGeneral,
  switchUser,
  resetLoginActionState,
} from "../../store/actions";
import { Icon } from "@iconify/react/dist/iconify.js";
import Logo from "../../assets/images/Logo.png";
import { theme } from "../../assets/theme/theme";
import logo from "../../assets/images/Logo.png";

const SarawakLogo = () => (
  <div
    style={{
      background: "#FFFFFF",
      borderRadius: "12px",
      padding: "12px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: "16px",
    }}
  >
    <img
      src={logo}
      alt="BESarawak Logo"
      style={{
        width: "120px",
        height: "auto",
        objectFit: "contain",
      }}
    />
  </div>
);

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pathName: this.props.router.location.pathname,
    };
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  componentDidMount() {
    this.props.resetLoginActionState();
    this.props.getGeneral();
    this.initMenu();
  }

  UNSAFE_componentDidUpdate(prevProps) {
    if (this.props.type !== prevProps.type) {
      this.initMenu();
    }

    if (this.props.router.location.pathname !== prevProps.router.location.pathname) {
      this.setState({ pathName: this.props.router.location.pathname }, () => {
        this.initMenu();
      });
    }
  }

  initMenu() {
    new MetisMenu("#side-menu");
  }

  toggleMenu() {
    this.props.toggleMenuCallback();
  }

  checkPathIncludes = (item) => {
    const path = this.props.router.location.pathname;
    return path.startsWith(item.route);
  };

  renderMenuItem = (item, key) => {
    const isActive = this.checkPathIncludes(item);
    const hasChildren = item.children && item.children.length > 0;

    return (
      <li key={key} style={{ listStyle: "none" }}>
        <Link
          to={hasChildren ? "#" : item.route}
          className={hasChildren ? "has-arrow sidebar-menu-link" : "sidebar-menu-link"}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            margin: "6px 14px",
            padding: "12px 14px",
            borderRadius: "12px",
            textDecoration: "none",
            backgroundColor: isActive ? theme.colors.brand.accent : "transparent",
            color: theme.colors.neutral.white,
            transition: "all 0.2s ease",
          }}
        >
          <Icon
            icon={item.icon}
            width="15"
            height="15"
            style={{
              color: theme.colors.neutral.white,
              opacity: isActive ? 1 : 0.9,
              flexShrink: 0,
            }}
          />

          <span
            style={{
              fontSize: "12px",
              fontWeight: 700,
              lineHeight: "22px",
              color: theme.colors.neutral.white,
              opacity: isActive ? 1 : 0.95,
            }}
          >
            {item.menu_item_label}
          </span>
        </Link>

        {hasChildren && (
          <ul className="sub-menu" style={{ paddingLeft: "28px" }}>
            {item.children.map((child, childIndex) => {
              const childActive = this.checkPathIncludes(child);

              return (
                <li key={childIndex} style={{ listStyle: "none" }}>
                  <Link
                    to={child.route}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      minHeight: "28px",
                      margin: "3px 6px",
                      padding: "0 12px",
                      borderRadius: "8px",
                      textDecoration: "none",
                      backgroundColor: childActive
                        ? theme.colors.brand.accent
                        : "transparent",
                      color: theme.colors.neutral.white,
                    }}
                  >
                    <Icon
                      icon={child.icon}
                      width="13"
                      height="13"
                      style={{
                        color: theme.colors.neutral.white,
                        opacity: childActive ? 1 : 0.8,
                        flexShrink: 0,
                      }}
                    />

                    <span
                      style={{
                        fontSize: "11px",
                        fontWeight: 600,
                        lineHeight: "20px",
                        color: theme.colors.neutral.white,
                        opacity: childActive ? 1 : 0.85,
                      }}
                    >
                      {child.menu_item_label}
                    </span>
                  </Link>
                </li>
              );
            })}
          </ul>
        )}
      </li>
    );
  };

  renderSectionTitle = (title, key) => {
    return (
      <div
        key={key}
        style={{
          padding: "20px 20px 8px",
          ...theme.typography.overline,
          color: "rgba(255,255,255,0.55)",
        }}
      >
        {title}
      </div>
    );
  };

  render() {
    const sidebarItems = [
      {
        category: "MAIN",
        items: [
          {
            icon: "mdi:view-dashboard-outline",
            menu_item_label: "Dashboard",
            route: "/dashboard",
          },
          {
            icon: "mdi:airplane",
            menu_item_label: "Travel & Budget",
            route: "/travel",
          },
          {
            icon: "mdi:school-outline",
            menu_item_label: "Training",
            route: "/training",
            children: [
              {
                menu_item_label: "Training Request",
                route: "/training/request",
              },
              {
                menu_item_label: "Training Evaluations",
                route: "/training/evaluations",
              }
            ],
          },
          {
            icon: "mdi:file-document-outline",
            menu_item_label: "Claim",
            route: "/claim",
          },
          {
            icon: "mdi:check-decagram-outline",
            menu_item_label: "Approval",
            route: "/approval",
          },
        ],
      },
      {
        category: "FINANCE & REPORTS",
        items: [
          {
            icon: "mdi:currency-usd",
            menu_item_label: "Finance",
            route: "/finance",
          },
          {
            icon: "mdi:chart-bar",
            menu_item_label: "Reports",
            route: "/reports",
          },
        ],
      },
      {
        category: "ADMINISTRATION",
        items: [
          {
            icon: "mdi:cog-outline",
            menu_item_label: "Administration",
            route: "/admin",
          },
        ],
      },
    ];

    return (
      <div
        id="sidebar-menu"
        style={{
          minHeight: "100vh",
          width: "100%",
          backgroundColor: theme.colors.brand.primary,
          display: "flex",
          flexDirection: "column",
          borderRight: "none",
        }}
      >
        <div
          style={{
            padding: "24px 20px 18px",
          }}
        >
          <Link
            to="/dashboard"
            style={{
              textDecoration: "none",
              color: theme.colors.neutral.white,
              display: "block",
            }}
          >
            <SarawakLogo />
          </Link>
        </div>

        <ul
          className="metismenu list-unstyled"
          id="side-menu"
          style={{
            padding: 0,
            margin: 0,
            flex: 1,
          }}
        >
          {sidebarItems.map((group, groupIndex) => (
            <React.Fragment key={groupIndex}>
              {this.renderSectionTitle(group.category, `title-${groupIndex}`)}
              {group.items.map((item, index) =>
                this.renderMenuItem(item, `${groupIndex}-${index}`)
              )}
            </React.Fragment>
          ))}
        </ul>

        <div
          style={{
            margin: "28px 25px 34px",
            paddingTop: "21px",
            color: "rgba(255,255,255,0.72)",
            borderTop: "1px solid rgba(255,255,255,0.62)",
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "20px",
          }}
        >
          <div>&copy; 2026 BESarawak</div>
          <div>All rights reserved.</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
    verifyAdmin: state.Login.verifyAdmin,
    currentUser: state.Login.verifyAdmin?.user?.data?.profile,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    changeLayout,
    changeSidebarTheme,
    changeSidebarType,
    changeLayoutWidth,
    changePreloader,
    verify_admin,
    resetLoginActionState,
    getGeneral,
    switchUser,
  })(withTranslation()(SidebarContent))
);